/*----------------------------------------------------------------------------*\
  #COPY TO CLIPBOARD
\*----------------------------------------------------------------------------*/

// Imports
import { createNotice } from 'modules/shared/notice';
import { closeAllMenus, closeAllDrawers } from 'modules/shared/overflow-menu';

// Default module export
export default function(options) {
  // Private: Default settings object
  const _defaults = {
    selector: '.copy-me',
    $copyEls() {
      return document.querySelectorAll(this.selector);
    },
    exists() {
      return this.$copyEls().length > 0;
    },
  };

  // Private: Merge passed in object with defaults
  const _settings = {
    ..._defaults,
    ...options,
  };

  // Private: Copy the element's data-copy value to the clipboard
  const _copyToClipboard = event => {
    event.preventDefault();

    // Closes all overflow menus and mobile drawers upon choosing View Doc
    closeAllMenus();
    closeAllDrawers();

    const $el = event.currentTarget;
    const value = $el.dataset.copy;

    if (!value) return;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(value);
      createNotice(value + ' copied to clipboard.');
      return;
    }

    // Fallback for browsers without Clipboard API support
    const $textarea = document.createElement('textarea');
    $textarea.value = value;
    $textarea.setAttribute('readonly', '');
    $textarea.style.position = 'absolute';
    $textarea.style.left = '-9999px';
    document.body.appendChild($textarea);
    $textarea.select();
    document.execCommand('copy');
    document.body.removeChild($textarea);
    createNotice(value + ' copied to clipboard.');
  };

  // Public: Destroy module instance
  const destroy = () => {
    if (!_settings.exists()) return;
    _settings.$copyEls().forEach($el => {
      $el.removeEventListener('click', _copyToClipboard);
    });
  };

  // Public: Destroy module instance and run initialise again
  const reinit = () => {
    destroy();
    init();
  };

  // Public: Initialise module
  const init = () => {
    if (!_settings.exists()) return;
    _settings.$copyEls().forEach($el => {
      $el.addEventListener('click', _copyToClipboard);
    });
  };

  // Return public methods
  return {
    destroy,
    reinit,
    init,
  };
}
